import { routerReducer } from "@ngrx/router-store";

export const routingFeatureKey = "routing";
export const routingSlice = routerReducer;
